import { get, reduce } from 'lodash';

export const convertAssignmentsIntoObject = serviceAssignments => reduce(serviceAssignments, (acc, assignment) => {
  acc[assignment.assigneeId] = assignment;

  if (assignment.assignments) {
    acc[assignment.assigneeId].assignments = convertAssignmentsIntoObject(assignment.assignments);
  }

  return acc;
}, {});

export const getPath = (row) => {
  const shopId = row.shopId || row.id;
  const barberId = row.id;
  if (barberId && shopId !== barberId) {
    return [shopId, 'assignments', barberId];
  }

  return shopId;
};

export const getAssignment = (serviceAssignments, row) => get(serviceAssignments, getPath(row));

const getAssignmentField = (assignment, fieldName) => get(assignment, fieldName, null);

const getFirstNotNull = array => array.find(value => value !== null);

export const getFieldValue = (service, serviceAssignments, row, fieldName) => {
  const { shopId, id } = row;
  const brandValue = get(service, fieldName);

  if (shopId) {
    return getFirstNotNull([
      getAssignmentField(getAssignment(serviceAssignments, row), fieldName),
      getAssignmentField(get(serviceAssignments, shopId), fieldName),
      brandValue,
    ]);
  }

  return getFirstNotNull([
    getAssignmentField(get(serviceAssignments, id), fieldName),
    brandValue,
  ]);
};
